// src/components/HomePage/ZeroDayBanner.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import bannerSteve from '../../assets/banner_steve.png';
import bannerText from '../../assets/banner_text_clean.png';

const ZeroDayBanner = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';
  const targetRoute = isEn ? '/en/secret' : '/secret';

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className="w-full mb-10 sm:mb-14 select-none"
    >
      <Link
        to={targetRoute}
        className="group relative block w-full h-[155px] sm:h-[195px] md:h-[225px] rounded-2xl sm:rounded-3xl border-2 border-white/10 hover:border-emerald-500/60 bg-[#020307] transition-colors duration-250 overflow-hidden"
      >
        {/* Внутренний контейнер: центрирование по высоте */}
        <div className="relative z-20 flex items-center justify-between h-full px-5 sm:px-8 lg:px-12 py-3 sm:py-5">
          {/* Левая часть: Вырезанный Текст и Описание */}
          <div className="flex flex-col justify-center max-w-[64%] sm:max-w-[56%] lg:max-w-[52%] z-20">

            {/* Вырезанный чистый текст */}
            <div>
              <img
                src={bannerText}
                alt="Gpt 6 Astra в ZeroDay Method"
                className="h-auto w-full max-w-[240px] sm:max-w-[360px] md:max-w-[420px] lg:max-w-[480px] object-contain filter drop-shadow-[0_4px_20px_rgba(0,0,0,0.8)]"
                draggable="false"
              />
            </div>

            {/* Описание */}
            <p className="hidden md:block text-xs lg:text-sm text-neutral-400 font-normal leading-relaxed mt-1 sm:mt-1.5 line-clamp-2 max-w-lg pl-1 sm:pl-1.5">
              {isEn
                ? 'Autonomous intelligent neural engine for deep security auditing, 0-day exploits, and core penetration testing.'
                : 'Автономная нейросеть нового поколения для поиска 0-day уязвимостей, глубокого анализа кода и аудита ядер серверов.'}
            </p>
          </div>

          {/* Правая часть: Стив на всю высоту карточки */}
          <div className="absolute right-0 top-0 bottom-0 h-full w-[54%] sm:w-[48%] md:w-[45%] pointer-events-none overflow-hidden flex items-center justify-end z-10">
            {/* Мягкий переход устраняет любые стыки */}
            <div className="absolute inset-y-0 left-0 w-16 sm:w-32 bg-gradient-to-r from-[#020307] via-[#020307]/80 to-transparent z-10" />

            <img
              src={bannerSteve}
              alt="Steve AI Cyber Hacking"
              className="h-full w-full object-cover object-left sm:object-cover select-none group-hover:scale-[1.03] transition-transform duration-500 ease-out"
              draggable="false"
            />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ZeroDayBanner;
